import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Button } from 'react-bootstrap'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import GreyHeader from '../../component/GreyHeader'
import DriversPage from './DriversPage'
import DriversScoring from './DriversScoring'
import DriversCoaching from './DriversCoaching'
import UnknownDriverTrips from './UnknownDriverTrips'
import DebugSnapshots from './DebugSnapshots'

const DriversContainer = (props) => {
	const { t } = useTranslation('translation', { keyPrefix: 'driversPage.driversContainer' });
	const { location, user, isUsingDriverFaceID } = props;
	const userRole = user.roles[0];
	const [tabKey, setTabKey] = useState(1);

	const isProd = location.hostname === 'fleet.roscolive.com';

	const handleNavigation = (tabKey) => {
		setTabKey(tabKey);
	}

	return (
		<div className="drivers-page">
			<GreyHeader
				title={t('titleDrivers')}
				renderSubtitle={
					<nav className='page-subtitle block'>
						<Button variant='subtitle' className={classNames('subtitle-nav', { 'active': tabKey === 1 })} onClick={() => handleNavigation(1)}>
							{t('btnAtAGlance')}
						</Button>
						<Button variant='subtitle' className={classNames('subtitle-nav', { 'active': tabKey === 2 })} onClick={() => handleNavigation(2)}>
							{t('btnScoring')}
						</Button>
						<Button variant='subtitle' className={classNames('subtitle-nav', { 'active': tabKey === 3 })} onClick={() => handleNavigation(3)}>
							{t('btnCoaching')}
						</Button>
						{!['partner_view', 'sales_demo'].includes(userRole) &&
							(<Button variant='subtitle' className={classNames('subtitle-nav', { 'active': tabKey === 4 })} onClick={() => handleNavigation(4)}>
								{t('btnUnknownDrivers')}
							</Button>
							)}
						{!isProd &&
							(<Button variant='subtitle' className={classNames('subtitle-nav', { 'active': tabKey === 5 })} onClick={() => handleNavigation(5)}>
								{t('btnDebugSnapshots')}
							</Button>)}
					</nav>
				}
			/>

			{tabKey === 1 &&
				<DriversPage
					location={location}
					isUsingDriverFaceID={isUsingDriverFaceID}
				/>
			}
			{tabKey === 2 &&
				<DriversScoring />
			}
			{tabKey === 3 &&
				<DriversCoaching />
			}
			{tabKey === 4 &&
				<UnknownDriverTrips
					location={location}
					isUsingDriverFaceID={isUsingDriverFaceID}
				/>
			}
			{tabKey === 5 &&
				<DebugSnapshots />
			}
		</div>
	);
};

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company,
	}),
)(DriversContainer);
